import { HMSPeer, useVideo } from "@100mslive/react-sdk";
import { useEffect } from "react";
import "./Peer.css";

type PeerProps = {
  peer: HMSPeer;
  className?: string;
  isMain?: boolean;
};

function Peer({ peer, className, isMain }: PeerProps) {
  const videoRef = useVideo({
    trackId: peer.videoTrack,
  });

  return (
    <div className={isMain ? "peer-container" : "small-peer-container"}>
      <video
        ref={videoRef.videoRef}
        className={isMain ? `peer-video ` : `small-peer-video`}
        autoPlay
        muted
        playsInline
        {...(isMain ? { height: "100%" } : {})}
      />
      <div className="selected-peer-name">
        {peer?.name} {peer?.isLocal ? "(You)" : ""}
      </div>
    </div>
  );
}

export default Peer;
